(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('OptionsCtrl', optionsCtrl);

    function optionsCtrl($scope, $sce, $window, $location, $timeout, ConfigService) {
        $scope.iFrameUrl = ConfigService.customilyOptionsUrl + '?origin=' + encodeURIComponent(window.location.origin);

        // Get an object generated from the URL which is needed to load the iFrame src dynamically
        $scope.iFrameUrl = $sce.trustAsResourceUrl($scope.iFrameUrl);

        $window.addEventListener(
            'message',
            function (event) {
                // Go to home if the back button on the iframe was pressed
                if (event.origin === ConfigService.customilyOptionsUrl) {
                    if (event.data.action === 'back') {
                        $timeout(function () {
                            $location.path('/');
                            $scope.$apply();
                        });
                    }
                }
            },
            false
        );
    }
})();
